import { render, staticRenderFns } from "./InstructionalView.vue?vue&type=template&id=115a5cee&scoped=true"
import script from "./InstructionalView.vue?vue&type=script&lang=js"
export * from "./InstructionalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115a5cee",
  null
  
)

export default component.exports